import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { login } from '../services/api';
import './Login.css';

function Login({ onLogin }) {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const response = await login(formData.email, formData.password);
      // El token va en cookie httpOnly — solo guardamos datos de usuario para la UI
      localStorage.setItem('user', JSON.stringify(response.data.user));
      onLogin(response.data.user);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Credenciales incorrectas. Inténtalo de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-root">
      {/* Left panel */}
      <div className="login-panel-left" aria-hidden="true">
        <div className="login-panel-brand">
          <div className="login-panel-logo">
            <svg width="28" height="28" viewBox="0 0 32 32" fill="none">
              <path d="M16 4L4 12V28H12V20H20V28H28V12L16 4Z" fill="white"/>
            </svg>
          </div>
          <span className="login-panel-brand-name">HabitaPro</span>
        </div>
        <div className="login-panel-content">
          <h2 className="login-panel-headline">Tu comunidad,<br/>conectada<span className="login-panel-dot">.</span></h2>
          <p className="login-panel-sub">Gestiona incidencias, reservas, documentos y comunicaciones desde un solo lugar.</p>
          <ul className="login-panel-features">
            <li>
              <span className="login-feature-icon">⚡</span>
              <span>Incidencias resueltas hasta un 60% más rápido</span>
            </li>
            <li>
              <span className="login-feature-icon">📅</span>
              <span>Reserva zonas comunes en segundos</span>
            </li>
            <li>
              <span className="login-feature-icon">🔔</span>
              <span>Notificaciones en tiempo real para todos</span>
            </li>
            <li>
              <span className="login-feature-icon">🔒</span>
              <span>Datos seguros y privacidad garantizada</span>
            </li>
          </ul>
        </div>
        <div className="login-panel-footer">
          <div className="login-panel-avatars">
            <div className="login-avatar" style={{background:'#818CF8'}}>A</div>
            <div className="login-avatar" style={{background:'#34D399'}}>M</div>
            <div className="login-avatar" style={{background:'#FB923C'}}>R</div>
            <div className="login-avatar" style={{background:'#F472B6'}}>S</div>
          </div>
          <p className="login-panel-social-proof">Gestión digital para comunidades de vecinos</p>
        </div>
      </div>

      {/* Right panel – form */}
      <div className="login-panel-right">
        <div className="login-form-wrap">
          <div className="login-form-header">
            <div className="login-form-logo-sm">
              <svg width="20" height="20" viewBox="0 0 32 32" fill="none">
                <path d="M16 4L4 12V28H12V20H20V28H28V12L16 4Z" fill="white"/>
              </svg>
            </div>
            <h1 className="login-form-title">Bienvenido de nuevo</h1>
            <p className="login-form-sub">Accede a tu comunidad</p>
          </div>

          {error && (
            <div className="login-error-box" role="alert">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="login-form" noValidate>
            <div className="login-field">
              <label className="login-label" htmlFor="login-email">Correo electrónico</label>
              <div className="login-input-wrap">
                <span className="login-input-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
                  </svg>
                </span>
                <input
                  id="login-email"
                  type="email"
                  name="email"
                  className="login-input"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="tu@email.com"
                  autoComplete="email"
                />
              </div>
            </div>

            <div className="login-field">
              <div className="login-label-row">
                <label className="login-label" htmlFor="login-password">Contraseña</label>
                <Link to="/forgot-password" className="login-forgot">¿La olvidaste?</Link>
              </div>
              <div className="login-input-wrap">
                <span className="login-input-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                  </svg>
                </span>
                <input
                  id="login-password"
                  type={showPass ? 'text' : 'password'}
                  name="password"
                  className="login-input"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  placeholder="••••••••"
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="login-toggle-pass"
                  onClick={() => setShowPass(v => !v)}
                  aria-label={showPass ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                >
                  {showPass ? (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/>
                    </svg>
                  ) : (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
                    </svg>
                  )}
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="login-submit"
              disabled={loading}
            >
              {loading ? (
                <span className="login-spinner" />
              ) : (
                <>
                  Iniciar sesión
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
                  </svg>
                </>
              )}
            </button>
          </form>

          <p className="login-register-link">
            ¿Aún no tienes cuenta?{' '}
            <Link to="/register">Regístrate gratis</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;
